import {
  CarouselNextButton,
  CarouselPrevButton,
} from "@aleksundshantu/aunds-utils-react/primitives/carousel";
import styles from "./SliderControls.module.scss";

type SliderControlsProps = {
  iconLabelNext?: string;
  iconLabelPrev?: string;
  className?: string;
};

export const SliderControls = ({
  iconLabelNext = "arrowRightGrid",
  iconLabelPrev = "arrowLeftGrid",
  className,
}: SliderControlsProps) => {
  return (
    <div className={`${styles["slider-controls"]} ${className}`}>
      <CarouselPrevButton iconLabel={iconLabelPrev} />
      <CarouselNextButton iconLabel={iconLabelNext} />
    </div>
  );
};
